import { render, staticRenderFns } from "./userInterAction.vue?vue&type=template&id=2b88f5ef&scoped=true&"
import script from "./userInterAction.vue?vue&type=script&lang=js&"
export * from "./userInterAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b88f5ef",
  null
  
)

export default component.exports